<template>
  <div class="card-body p-4">
    <div class="row">
      <div class="col-md-4">
        <NavbarForums :activeOption="option" @selectOption="selectOption" />
      </div>
      <div class="col-md-8">
        <div v-if="option == 'categories'">
          <ForumCategories />
        </div>
        <div v-else-if="option == 'conversations'">
          <ForumConversations />
        </div>
        <div v-else class="text-center py-5 text-muted">
          Seleccione una opción del menú
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarForums from "@/components/Layout/NavbarForums.vue";
import ForumCategories from "@/components/Forums/views/Categories.vue";
import ForumConversations from "@/components/Forums/views/Conversations.vue";
import UserService from "@/services/user.service.js";

export default {
  name: "Forums",
  components: {
    NavbarForums,
    ForumCategories,
    ForumConversations,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      users: [],
      option: "", // Starts empty, will be filled in created()
    };
  },
  methods: {
    async getUsers() {
      const response = await UserService.getAllUsers();
      this.users = response.data;
    },
    selectOption(option) {
      this.option = option;
      // Save the choice so the back button/refresh remembers it
      localStorage.setItem("last_forum_option", option);
    },
  },
  created() {
    this.getUsers();
    
    // Check if there is a saved preference
    const savedOption = localStorage.getItem("last_forum_option");
    if (savedOption) {
      this.option = savedOption;
    } else {
      // Default fallback if nothing is saved
      this.option = "conversations"; 
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>